import React from 'react';
import { ctaHref, ctaIsExternal } from '../config/site';
interface CTAButtonProps {
  label: string;
  microcopy?: string;
  className?: string;
  /** Nadpisuje docelowy adres tylko dla tego jednego przycisku. */
  href?: string;
}
export function CTAButton({
  label,
  microcopy,
  className = '',
  href: hrefOverride
}: CTAButtonProps) {
  const href = hrefOverride || ctaHref();
  const external = hrefOverride ? /^https?:\/\//.test(hrefOverride) : ctaIsExternal();
  return <div className={`relative z-20 w-full ${className}`} data-id="element-140" data-mp="2p09my535m58p">
      <a href={href} {...external ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} className="cta-button flex min-h-[58px] w-full items-center justify-center rounded-xl bg-cta px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-tight text-white hover:bg-cta-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cta sm:text-base" data-id="element-141" data-mp="2ozqerg3b2v7v">
        {label}
      </a>
      {microcopy && <p className="mt-3 text-center text-xs text-ink/60 sm:text-sm" data-id="element-142" data-mp="199y7eb42dt25">{microcopy}</p>}
    </div>;
}